/**
 * Simulates a click on the filter button after a delay
 */
// function simulateFilterButtonClick() {
//   // Add a delay before executing the click simulation
//   setTimeout(function () {
//     // Get the filter button
//     const filterButton = document.querySelector(".btn-filters");

//     // If the button exists, create and dispatch a click event on it
//     if (filterButton) {
//       // Create a new click event
//       const clickEvent = new MouseEvent("click", {
//         bubbles: true,
//         cancelable: true,
//         view: window,
//       });

//       // Dispatch the event on the button
//       filterButton.dispatchEvent(clickEvent);
//     }
//   }, 500); // 500ms delay
// }

// document.addEventListener("DOMContentLoaded", function () {
//   simulateFilterButtonClick();
// });

///////////////////////////////////////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  // Set up all event handlers
  setupFilterModal();
  setupFilterSectionToggles();
  setupCategoryCheckboxes();
  setupPriceCheckboxes();
  setupFlavourCheckboxes();
  setupCakeTypeCheckboxes();
  setupDietaryCheckboxes();
  setupSizeCheckboxes();
  setupColourCheckboxes();
  setupAvailabilityCheckboxes();
  setupShippingClassCheckboxes()
  setupLeadTimeCheckboxes() 
  setupApplyFilterButton();
  setupClearFilterButton();
});

/**
 * Set up the filter modal open/close functionality
 */
/* Then update your filter open function like this */
function setupFilterModal() {
    const filterButton = document.querySelector(".btn-filters");
    const filterBackground = document.querySelector(".product-filter__background");
    const filterContainer = document.querySelector(".product-filter-container");
    const closeIcon = document.querySelector(".product-filter__close-icon");
    const body = document.body;
    
    if (filterButton && filterBackground && filterContainer) {
      // Add click event listener to the filter button
      filterButton.addEventListener("click", function () {
        // Save the current scroll position
        const scrollY = window.scrollY;
        
        // Get the scrollbar width
        const scrollbarWidth = getScrollbarWidth();
        
        // Toggle is-open class on the background and container
        filterBackground.classList.add("is-open");
        filterContainer.classList.add("is-open");
        
        // Add filters-open class to body
        body.classList.add("filters-open");
        
        // Compensate for scrollbar disappearing to prevent page jump
        body.style.paddingRight = scrollbarWidth + 'px';
        
        // Force the page to maintain scroll position
        body.style.top = `-${scrollY}px`;
      });
      
      // Function to close filter
      const closeFilter = function() {
        // Get the body's top position
        const scrollY = parseInt(body.style.top || '0') * -1;
        
        // Remove classes
        filterBackground.classList.remove("is-open");
        filterContainer.classList.remove("is-open");
        body.classList.remove("filters-open");
        
        // Remove padding compensation
        body.style.paddingRight = '';
        body.style.top = '';
        
        // Restore scroll position
        window.scrollTo(0, scrollY);
      };
      
      // Rest of your existing event listeners for closing
      filterBackground.addEventListener("click", function (event) {
        if (event.target === filterBackground) {
          closeFilter();
        }
      });
      
      if (closeIcon) {
        closeIcon.addEventListener("click", function () {
          closeFilter();
        });
      }
      
      document.addEventListener("keydown", function (event) {
        if (
          event.key === "Escape" &&
          filterBackground.classList.contains("is-open")
        ) {
          closeFilter();
        }
      });
    }
  }

/**
 * Set up accordion toggle for filter sections
 */
function setupFilterSectionToggles() {
  // Add is-collapsed class to all sections by default
  const filterSections = document.querySelectorAll(".product-filter__section");
  filterSections.forEach((section) => {
    section.classList.add("is-collapsed");
  });

  // Add click listeners to section headers
  const sectionHeaders = document.querySelectorAll(
    ".product-filter__section-header"
  );
  sectionHeaders.forEach((header) => {
    header.addEventListener("click", function () {
      const section = this.closest(".product-filter__section");
      section.classList.toggle("is-collapsed");
    });
  });

  // The toggle buttons are now redundant since we're using the entire header,
  // but we'll keep them in the markup for visual purposes
}

/**
 * Set up category filter checkboxes
 */
function setupCategoryCheckboxes() {
    const categoryCheckboxes = document.querySelectorAll(".category-checkbox");
    const categoryInput = document.getElementById("product_cat_input");

    if (categoryCheckboxes.length > 0 && categoryInput) {
        // Check if we're on a category page by examining the URL structure
        const isOnCategoryPage = window.location.pathname.indexOf('/shop/') === -1 && 
                                window.location.pathname !== '/' &&
                                window.location.pathname !== '/shop';
        
        // Set the correct input name based on page context
        if (isOnCategoryPage) {
            categoryInput.name = "child_cat";
        } else {
            categoryInput.name = "product_cat";
        }
        
        categoryCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", function () {
                // Get all selected category values WITHOUT duplicates
                const selectedCategories = [];
                categoryCheckboxes.forEach((cb) => {
                    if (cb.checked) {
                        const category = cb.getAttribute("data-category");
                        // Only add if not already in the array
                        if (!selectedCategories.includes(category)) {
                            selectedCategories.push(category);
                        }
                    }
                });

                // Update the hidden input with comma-separated values
                categoryInput.value = selectedCategories.join(",");
            });
        });
    }
}
/**
 * Set up price filter checkboxes
 */
function setupPriceCheckboxes() {
  const priceCheckboxes = document.querySelectorAll(".price-checkbox");
  const priceInput = document.getElementById("price_range_input");

  if (priceCheckboxes.length > 0 && priceInput) {
    priceCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        // Get all selected price range values
        const selectedPrices = [];
        priceCheckboxes.forEach((cb) => {
          if (cb.checked) {
            selectedPrices.push(cb.getAttribute("data-price-range"));
          }
        });

        // Update the hidden input with comma-separated values
        priceInput.value = selectedPrices.join(",");
      });
    });
  }
}


/**
 * Set up apply filter button with correct handling of empty filters
 * and clean URL parameters
 */
function setupApplyFilterButton() {
    const applyButton = document.querySelector(".product-filter__apply-btn");
    if (applyButton) {
        applyButton.addEventListener("click", function (e) {
            e.preventDefault();

            // Get current path (remove any pagination)
            const currentPath = window.location.pathname.replace(/\/page\/\d+\//g, '/');
            
            // Check if any category checkboxes are checked
            const categoryCheckboxes = document.querySelectorAll(".category-checkbox");
            const hasCategorySelected = Array.from(categoryCheckboxes).some(cb => cb.checked);
            
            // Create a clean params object
            let params = {};
            
            // Add parameters only if they have a value
            // For sorting and per page
            const sortingSelect = document.getElementById("shop-sorting");
            if (sortingSelect && sortingSelect.value && sortingSelect.value !== "default") {
                params["orderby"] = sortingSelect.value;
            }
            
            const perPageSelect = document.getElementById("shop-per-page");
            if (perPageSelect && perPageSelect.value) {
                params["per_page"] = perPageSelect.value;
            }
            
            // Category/Child Category - only add if at least one is checked
            if (hasCategorySelected) {
                const selectedCategories = [];
                categoryCheckboxes.forEach(cb => {
                    if (cb.checked) {
                        selectedCategories.push(cb.getAttribute("data-category"));
                    }
                });
                
                // Determine if we're on a category page
                const isOnCategoryPage = currentPath.indexOf('/shop/') === -1 && 
                                        currentPath !== '/' &&
                                        currentPath !== '/shop';
                
                // Add the appropriate parameter
                if (selectedCategories.length > 0) {
                    if (isOnCategoryPage) {
                        params["child_cat"] = selectedCategories.join(",");
                    } else {
                        params["product_cat"] = selectedCategories.join(",");
                    }
                }
            }
            
            // Handle other filter types similarly
            const filterTypes = [
                { checkboxClass: ".price-checkbox", paramName: "price_range", dataAttr: "data-price-range" },
                { checkboxClass: ".flavour-checkbox", paramName: "flavours", dataAttr: "data-flavour" },
                { checkboxClass: ".cake-type-checkbox", paramName: "cake_type", dataAttr: "data-cake-type" },
                { checkboxClass: ".size-checkbox", paramName: "size", dataAttr: "data-size" },
                { checkboxClass: ".colour-checkbox", paramName: "colour", dataAttr: "data-colour" },
                { checkboxClass: ".availability-checkbox", paramName: "availability", dataAttr: "data-availability" },
                { checkboxClass: ".shipping-class-checkbox", paramName: "shipping_class", dataAttr: "data-shipping-class" },
                { checkboxClass: ".lead-time-checkbox", paramName: "lead_time", dataAttr: "data-lead-time" }
            ];

            const dietaryCheckboxes = document.querySelectorAll(".dietary-checkbox");
            const selectedDietary = [];

            dietaryCheckboxes.forEach(cb => {
              if (cb.checked) {
                selectedDietary.push(cb.getAttribute("data-dietary"));
              }
            });
            
            filterTypes.forEach(filterType => {
                const checkboxes = document.querySelectorAll(filterType.checkboxClass);
                const hasChecked = Array.from(checkboxes).some(cb => cb.checked);
                
                if (hasChecked) {
                    const selected = [];
                    checkboxes.forEach(cb => {
                        if (cb.checked) {
                            selected.push(cb.getAttribute(filterType.dataAttr));
                        }
                    });
                    
                    if (selected.length > 0) {
                        params[filterType.paramName] = selected.join(",");
                    }
                }
            });
            
            const queryParts = [];
            for (const key in params) {
                if (params[key]) {
                    const value = params[key].replace(/,/g, '%2C');
                    const cleanValue = value.replace(/%2C/g, ',');
                    queryParts.push(encodeURIComponent(key) + "=" + cleanValue);
                }
            }
            
            let useDietaryUrl = selectedDietary.length > 0;
            let dietaryValue = selectedDietary.length > 0 ? selectedDietary[0] : "";
            let newUrl;

            if (useDietaryUrl) {
              newUrl = "/dietary/" + dietaryValue;
              if (queryParts.length > 0) {
                newUrl += "?" + queryParts.join("&");
              }
            } else {
              newUrl = currentPath;
              if (queryParts.length > 0) {
                newUrl += "?" + queryParts.join("&");
              }
            }

            window.location.href = newUrl;
        });
    }
}

/**
 * Set up clear filter button
 */
function setupClearFilterButton() {
  const clearButton = document.querySelector(".product-filter__clear-btn");
  
  if (clearButton) {
    clearButton.addEventListener("click", function (e) {
      e.preventDefault();
      
      // Detect page type and set appropriate clear URL
      const currentPath = window.location.pathname.toLowerCase();
      const isShopPage = currentPath === '/shop/' || currentPath === '/shop' || currentPath.startsWith('/shop/');
      
      if (isShopPage) {
        // On shop page - go to clean shop URL
        window.location.href = "/shop";
      } else {
        // On category page - go to clean category URL
        // Remove any query parameters and pagination to get clean category URL
        const cleanUrl = currentPath.replace(/\/page\/\d+\//g, '/').replace(/\/$/, '') + '/';
        window.location.href = cleanUrl;
      }
    });
  }
}

/**
 * Set up flavour filter checkboxes
 */
function setupFlavourCheckboxes() {
  const flavourCheckboxes = document.querySelectorAll(".flavour-checkbox");
  const flavourInput = document.getElementById("flavours_input");

  if (flavourCheckboxes.length > 0 && flavourInput) {
    flavourCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        // Get all selected flavour values
        const selectedFlavours = [];
        flavourCheckboxes.forEach((cb) => {
          if (cb.checked) {
            selectedFlavours.push(cb.getAttribute("data-flavour"));
          }
        });

        // Update the hidden input with comma-separated values
        flavourInput.value = selectedFlavours.join(",");
      });
    });
  }
}

/**
 * Set up cake type filter checkboxes
 */
function setupCakeTypeCheckboxes() {
  const cakeTypeCheckboxes = document.querySelectorAll(".cake-type-checkbox");
  const cakeTypeInput = document.getElementById("cake_type_input");

  if (cakeTypeCheckboxes.length > 0 && cakeTypeInput) {
    cakeTypeCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        // Get all selected cake type values
        const selectedCakeTypes = [];
        cakeTypeCheckboxes.forEach((cb) => {
          if (cb.checked) {
            selectedCakeTypes.push(cb.getAttribute("data-cake-type"));
          }
        });

        // Update the hidden input with comma-separated values
        cakeTypeInput.value = selectedCakeTypes.join(",");
      });
    });
  }
}


/**
 * Set up dietary restrictions filter checkboxes
 */
function setupDietaryCheckboxes() {
    const dietaryCheckboxes = document.querySelectorAll('.dietary-checkbox');
    const dietaryInput = document.getElementById('dietary_input');
    
    if (dietaryCheckboxes.length > 0 && dietaryInput) {
      dietaryCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
          // Get all selected dietary restriction values
          const selectedDietary = [];
          dietaryCheckboxes.forEach(cb => {
            if (cb.checked) {
              selectedDietary.push(cb.getAttribute('data-dietary'));
            }
          });
          
          // Update the hidden input with comma-separated values
          dietaryInput.value = selectedDietary.join(',');
        });
      });
    }
}

/**
 * Set up size filter checkboxes
 */
function setupSizeCheckboxes() {
    const sizeCheckboxes = document.querySelectorAll('.size-checkbox');
    const sizeInput = document.getElementById('size_input');
    
    if (sizeCheckboxes.length > 0 && sizeInput) {
      sizeCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
          // Get all selected size values
          const selectedSizes = [];
          sizeCheckboxes.forEach(cb => {
            if (cb.checked) {
              selectedSizes.push(cb.getAttribute('data-size'));
            }
          });
          
          // Update the hidden input with comma-separated values
          sizeInput.value = selectedSizes.join(',');
        });
      });
    }
}

/**
 * Set up colour filter checkboxes
 */
function setupColourCheckboxes() {
    const colourCheckboxes = document.querySelectorAll('.colour-checkbox');
    const colourInput = document.getElementById('colour_input');
    
    if (colourCheckboxes.length > 0 && colourInput) {
      colourCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
          // Get all selected colour values
          const selectedColours = [];
          colourCheckboxes.forEach(cb => {
            if (cb.checked) {
              selectedColours.push(cb.getAttribute('data-colour'));
            }
          });
          
          // Update the hidden input with comma-separated values
          colourInput.value = selectedColours.join(',');
        });
      });
    }
}

/**
 * Set up availability filter checkboxes
 */
function setupAvailabilityCheckboxes() {
    const availabilityCheckboxes = document.querySelectorAll('.availability-checkbox');
    const availabilityInput = document.getElementById('availability_input');
    
    if (availabilityCheckboxes.length > 0 && availabilityInput) {
      availabilityCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
          // Get all selected availability values
          const selectedAvailability = [];
          availabilityCheckboxes.forEach(cb => {
            if (cb.checked) {
              selectedAvailability.push(cb.getAttribute('data-availability'));
            }
          });
          
          // Update the hidden input with comma-separated values
          availabilityInput.value = selectedAvailability.join(',');
        });
      });
    }
}

/**
 * Set up shipping class filter checkboxes
 */
function setupShippingClassCheckboxes() {
    const shippingClassCheckboxes = document.querySelectorAll('.shipping-class-checkbox');
    const shippingClassInput = document.getElementById('shipping_class_input');
    
    if (shippingClassCheckboxes.length > 0 && shippingClassInput) {
      shippingClassCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
          // Get all selected shipping class values
          const selectedShippingClasses = [];
          shippingClassCheckboxes.forEach(cb => {
            if (cb.checked) {
              selectedShippingClasses.push(cb.getAttribute('data-shipping-class'));
            }
          });
          
          // Update the hidden input with comma-separated values
          shippingClassInput.value = selectedShippingClasses.join(',');
        });
      });
    }
}

/**
 * Set up lead time filter checkboxes
 */
function setupLeadTimeCheckboxes() {
    const leadTimeCheckboxes = document.querySelectorAll('.lead-time-checkbox');
    const leadTimeInput = document.getElementById('lead_time_input');
    
    if (leadTimeCheckboxes.length > 0 && leadTimeInput) {
      leadTimeCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
          // Get all selected lead time values
          const selectedLeadTimes = [];
          leadTimeCheckboxes.forEach(cb => {
            if (cb.checked) {
              selectedLeadTimes.push(cb.getAttribute('data-lead-time'));
            }
          });
          
          // Update the hidden input with comma-separated values
          leadTimeInput.value = selectedLeadTimes.join(',');
        });
      });
    }
}


/* First add this JavaScript near the top of your script */
function getScrollbarWidth() {
    // Create a temporary div to measure scrollbar width
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);
    
    // Create inner div
    const inner = document.createElement('div');
    outer.appendChild(inner);
    
    // Calculate scrollbar width (outer width - inner width)
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    
    // Clean up
    outer.parentNode.removeChild(outer);
    
    return scrollbarWidth;
  }